import { RouterProvider } from '@tanstack/react-router';
import { LogtoProviderWrapper } from '@/app/providers/logto-provider';
import { QueryProvider } from '@/app/providers/query-provider';
import { router } from '@/app/providers/router/routes';
import { AuthProvider, SupabaseTokenSync } from '@/lib/auth';

export const App = () => (
  <LogtoProviderWrapper>
    <AuthProvider>
      <SupabaseTokenSync>
        <QueryProvider>
          <RouterProvider router={router} />
        </QueryProvider>
      </SupabaseTokenSync>
    </AuthProvider>
  </LogtoProviderWrapper>
);
